import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const pssMembershipFreeApiService = createApi({
  reducerPath: "pssMembershipFreeApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createPssMembershipFree: builder.mutation({
      query: ({ params, payload }) => {
        let query = queryParams(params);
        return {
          url: `pssmembership/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    updatePssMembershipFreeShowStatus: builder.mutation({
      query: ({ payload, params, id }) => {
        let query = queryParams(params);
        return {
          url: `pssmembership/update/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreatePssMembershipFreeMutation,
  useUpdatePssMembershipFreeShowStatusMutation,
} = pssMembershipFreeApiService;
